<div class="modal-dialog modal-lg" style="margin-top: 0px; margin-bottom: 0px">
  <div class="modal-content">
    <div class="modal-header">
      <button unity-button class="close" classes="icon-only icon-only-large on_dark" type="button" (click)="action('close')">
        <svg class="unity-icon unity-icon-times">
          <use xlink:href="#unity-icon-times"></use>
        </svg>
      </button>
      <h4 class="modal-title">Distribute Document</h4>
    </div>

    <div class="modal-body">
      <ep-panel panelType="transparent">
        <ep-row>
          <div class="col-12">
            <div
              *ngIf="(documentCount$ | async) > 1"
              style="display: inline-block; max-width: 100%; margin-bottom: 5px"
            >
              <ep-selector
                minButtonModeSize="nb"
                label="Multiple Documents"
                [values]="this._docList"
                [(value)]="this.model.currentDocID"
                (valueChange)="this.currentDocChanged()"
              >
              </ep-selector>
            </div>
          </div>
        </ep-row>
        <ep-row>
          <div class="col-12">
            <div
              *ngFor="let document of documents$ | async; trackBy: docTrackingID"
              style="display: inline-block; max-width: 100%; margin-bottom: 5px"
            >
              <ep-document-distribute-edit-panel
                *ngIf="model.currentDocID && document.Doc_ID == model.currentDocID"
                [document]="document"
                [documentCount]="documentCount$ | async"
              ></ep-document-distribute-edit-panel>
            </div>
            <div class="form-group">
              <action-menu
                ngProjectAs="ep-page-menu"
                layout="Hyperlink"
                [menuData]="documentDistributePageMenu"
                [parameters]="{}"
                (actionSelected)="menuHandler($event)"
              ></action-menu>
            </div>

            <div
              style="
                border-bottom-style: solid;
                border-bottom-width: 2px;
                border-bottom-color: black;
                margin-bottom: 2px;
              "
            >
              <ep-field format="container" columnSpan="45px" collapseLabelArea="true">
                <b style="font-size: 14px">File Only</b>
              </ep-field>
              <ep-field format="container" columnSpan="190px" collapseLabelArea="true"
                ><b style="font-size: 14px">Recipient</b></ep-field
              >
              <ep-field format="container" columnSpan="190px" collapseLabelArea="true"
                ><b style="font-size: 14px">Attention</b></ep-field
              >
              <ep-field format="container" columnSpan="25px" collapseLabelArea="true">
                <i class="fa fa-ep-public" style="font-size: 14px; margin-top: 3px; margin-left: 2px"></i>
              </ep-field>
              <ep-field format="container" columnSpan="25px" collapseLabelArea="true">
                <i
                  class="fa fa-ep-document-file-external"
                  style="font-size: 14px; margin-top: 3px; margin-left: 2px"
                ></i>
              </ep-field>
              <ep-field format="container" columnSpan="100px" collapseLabelArea="true"
                ><b style="font-size: 14px">Drawer</b></ep-field
              >
              <ep-field format="container" columnSpan="100px" collapseLabelArea="true"
                ><b style="font-size: 14px">Folder</b></ep-field
              >
            </div>
            <div
              *ngFor="let filing of filingsByDocID$ | async; trackBy: filingTrackingID"
              style="display: block; max-width: 100%"
            >
              <div style="margin-bottom: -10px">
                <ep-document-distribute-filing-edit-panel
                  [filing]="filing"
                  [parentDocID]="model.currentDocID"
                ></ep-document-distribute-filing-edit-panel>
              </div>
            </div>
          </div>
        </ep-row>

        <ep-row>
          <div *ngIf="(distMethodByDocID$ | async) == 'C'" class="col-12" style="margin-top: 5px">
            <ep-document-distribute-correspond-options-edit-panel></ep-document-distribute-correspond-options-edit-panel>
          </div>
        </ep-row>
      </ep-panel>

      <div class="modal-footer">
        <unity-button-old
          [disabled]="(distMethodByDocID$ | async) == ''"
          type="button"
          classes="primary"
          (click)="action('distribute')"
          >Distribute</unity-button-old>
        <unity-button-old type="button" classes="ghost" (click)="action('cancel')">Cancel</unity-button-old>
      </div>
    </div>
  </div>
</div>
